import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NotificationType = 'success' | 'info' | 'warning' | 'error'

export type NotificationData = {
  type?: NotificationType,
  title: string,
  message?: string,
  delay?: number
}

export type Notification = NotificationData & {
  id: number
}

export const useNotifyStore = defineStore('notify', () => {
  const notifications = ref<Notification[]>([])

  const showNotification = (data: NotificationData) => {
    const notification: Notification = {
      ...data,
      id: Date.now()
    }
    notifications.value.push(notification)
  }

  const deleteNotification = (id: number) => {
    notifications.value = notifications.value.filter((value) => {
      return value.id !== id
    })
  }

  const deleteNotifications = () => {
    notifications.value = []
  }

  return {
    notifications,
    showNotification,
    deleteNotification,
    deleteNotifications
  }
})
